export default function stringFormatter() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var quote = typeof opts.quote === 'string' ? opts.quote : '"';
  var escapedQuote = typeof opts.escapedQuote === 'string' ? opts.escapedQuote : "".concat(quote).concat(quote);

  if (!quote || quote === escapedQuote) {
    return function (value) {
      return value;
    };
  }

  var quoteRegExp = new RegExp(quote, 'g');
  return function (value) {
    if (value.includes(quote)) {
      value = value.replace(quoteRegExp, escapedQuote);
    }

    return "".concat(quote).concat(value).concat(quote);
  };
}